<div class="m-defective-flow-container">
  <ng-container *ngIf="isOperationSelectionStep">
    <monorepo-operation-selection-v3
      [bctxHeader]="bctxHeader"
      [departmentWiseOperationListAndGenericIssueMap]="departmentWiseOperationListAndGenericIssueMap"
      [departments]="departments"
      [selectedOperationList]="selectedOperationList"
      (cancel)="handleCancel()"
      (next)="handleOperationOrRecentDefectiveSelectionNext($event)"
      (clearAll)="handleOperationClearAll()"
      (onViewAll)="onViewAll($event)"
    ></monorepo-operation-selection-v3
  ></ng-container>
  <ng-container *ngIf="isRecentDefectiveSelectionStep">
    <monorepo-operation-selection-v3
      [bctxHeader]="bctxHeader"
      [recentDefectiveList]="recentDefectiveList"
      [isRecentDefectiveSelection]="isRecentDefectsSelection"
      [selectedOperationList]="selectedRecentDefectiveList"
      (cancel)="handleCancel()"
      (next)="handleOperationOrRecentDefectiveSelectionNext($event)"
      (clearAll)="handleOperationClearAll()"
    ></monorepo-operation-selection-v3
  ></ng-container>
  <ng-container *ngIf="isIssueSelectionStep">
    <monorepo-issue-selection-v3
      [departmentWiseOperationListAndGenericIssueMap]="departmentWiseOperationListAndGenericIssueMap"
      [operationAndSelectedIssueList]="operationAndSelectedIssueList"
      (back)="handleIssueSelectionBack($event)"
      (cancel)="handleCancel()"
      (next)="handleIssueSelectionNext($event)"
      (clearAll)="handleIssueClearAll()"
      (viewAll)="onViewAll($event)"
    ></monorepo-issue-selection-v3>
  </ng-container>
  <ng-container *ngIf="isMarkLocationStep">
    <monorepo-mark-location
      [operationIssueAndMarkedLocationsList]="operationIssueAndMarkedLocationsList"
      [silhouette_front]="defectSilhouetteData.silhouette_front"
      [silhouette_back]="defectSilhouetteData.silhouette_back"
      [shillohutteId]="defectSilhouetteData.silhoutteId"
      [showDepartmentName]="departments.length > 1"
      (cancel)="handleCancel()"
      (back)="handleMarkLocationBack($event)"
      (done)="handleDone($event)"
      (clearAll)="handleMarkLocationClearAll()"
      [isImageCapturingEnabled]="isImageCapturingEnabled"
      (addPhoto)="openCamera()"
    ></monorepo-mark-location>
  </ng-container>
</div>
